import { Button, Menu, MenuItem, useTheme } from '@mui/material';
import React from 'react'
import { useTranslation } from 'react-i18next';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export default function LanguageSwitcher() {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const { i18n: {changeLanguage, language} } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = React.useState(language)
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelect = (type) => {
    setAnchorEl(null);
   setCurrentLanguage(type);
   changeLanguage(type);
  };

  return (
    <div>
        <Button
          id="basic-button"
          aria-controls={open ? 'basic-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          style={{ flexDirection: 'row' }}
          sx={{
            minWidth: '100px',
            color: theme.palette.primary.text,
            backgroundColor: '#fff',
            borderRadius: '4px',
            textTransform: 'capitalize',
            fontSize: '12px',
            '&:hover': {
              color: theme.palette.primary.text,
            backgroundColor: '#fff',
            }
          }}
          endIcon={<KeyboardArrowDownIcon />}
        >
          {currentLanguage=== 'jp' ? 'Japanese': 'English' }
        </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        <MenuItem
          className="!text-[12px]"
          sx={{ color: '#313131', minWidth: '100px' }}
          onClick={() => handleSelect('en')}
        >
          English
        </MenuItem>
        <MenuItem
          className="!text-[12px]"
          sx={{ color: '#313131',minWidth: '100px' }}
          onClick={() => handleSelect('jp')}
        >
          Japanese
        </MenuItem>
      </Menu>
    </div>
  );
}
